export default function getEnvAsset(path: string) { return require(`@/assets/env/${process.env.VUE_APP_CLIENT}${path}`); }
